import React from 'react';
import ProfileAvatarImg from '../../../../components/Profile/ProfileAvatarImg';
import { Col } from 'reactstrap';
import { connect } from 'react-redux'

const ProfileCard = ({ profile }) => {
    const { email, img } = profile;
    return (
        <Col className="profile-card">
            <ProfileAvatarImg avatar={img} />
            <span className="email">{email}</span>
        </Col>
    )
}

const mapStateToProps = state => ({
    profile: state.webmaster.profile,
});

export default connect(mapStateToProps)(ProfileCard)